import EcertIndex from '../Views/EcertIndex'

const EcertRoute = [{
    path: '/ecert',
    name: 'ecert',
    component: EcertIndex,
}]

export default EcertRoute
